import React, { useState } from 'react';
import styles from './TeamOnboardingMemberList.less';
import {
  useTeamOnboardingMemberListQuery,
  useTeamOnboardingMemberListInviteMutation,
} from '@trello/graphql/generated';
import { Facepile } from 'app/src/components/Facepile';
import { forNamespace } from 'app/common/lib/util/i18n';
import ManageOrgMembersComponent from 'app/scripts/views/organization/manage-org-members-component/index.coffee';
import PopOver from 'app/scripts/views/lib/pop-over.coffee';
import { Button } from 'app/common/components/controls/button/button';
import { logError } from 'app/scripts/debug/log-error';
import { Feature } from 'app/scripts/debug/constants';
import { BCTeamOnboardingTestIds } from '@trello/test-ids';

const format = forNamespace('team onboarding');
interface TeamOnboardingMemberListProps {
  orgId: string;
  model: object; //backbone model, passed through to the ManageOrgMembersComponent
  modelCache: object;
}

export const TeamOnboardingMemberList: React.FC<TeamOnboardingMemberListProps> = ({
  orgId,
  model,
  modelCache,
}) => {
  const [selectedMembers] = useState<string[]>([]);
  const [addMembersToOrg] = useTeamOnboardingMemberListInviteMutation();

  const { data, refetch } = useTeamOnboardingMemberListQuery({
    variables: { orgId },
  });
  const memberIds = data?.organization?.members?.map((m) => m.id) || [];

  const inviteMembers = async () => {
    try {
      await addMembersToOrg({
        variables: {
          orgId,
          users: selectedMembers.map((idMember) => ({ id: idMember })),
        },
      });
    } catch (err) {
      logError({
        error: err,
        tags: {
          ownershipArea: 'trello-bizteam',
          feature: Feature.TeamOnboarding,
        },
      });
    }
  };

  const onSubmit = async () => {
    if (orgId) {
      await inviteMembers();
    }
  };

  const renderInviteMemberPopOverComponent = (e: React.MouseEvent) => {
    PopOver.toggle({
      elem: e.currentTarget,
      getViewTitle: () => format('invite'),
      role: 'dialog',
      reactElement: (
        <ManageOrgMembersComponent
          key="team-onboarding-member-list"
          model={model}
          modelCache={modelCache}
          addMembersCallback={refetch}
        />
      ),
    });
    onSubmit();
  };

  return (
    <div className={styles.memberListContainer}>
      <Facepile memberIds={memberIds} maxFaceCount={4} />
      <Button
        className={styles.inviteMemberButton}
        onClick={renderInviteMemberPopOverComponent}
        data-test-id={
          BCTeamOnboardingTestIds.BCTeamOnboardingInviteMemberButton
        }
      >
        {format(['invite'])}
      </Button>
    </div>
  );
};
